<template>
    <div class="careers-scholarships">
      <div class="careers-scholarships-content">
        <h1>Стипендиантски програми</h1>
        <ul>
          <li class="strong underline"><a href="/static/files/careers/alcomets-academy.pdf" target="_blank"><img class="full-width" src="/static/img/careers/careers.jpg" alt="Стипендиантски програми"></a></li>
        </ul>
<!--
        <p class="indent">Алкомет предлага отлични възможности за обучение и реализация на млади специалисти чрез студентски практики, разнообразни стажантски програми, индивидуални стипендии.</p>
        <ul>
            <li class="strong underline">Фирмени стажантски програми</li>
        </ul>
        <p class="strong">Продължителност:</p>
        <ul>
            <li class="underline">1 месец</li>
        </ul>
        <p class="strong">Условия на стажантските програми:</p>
        <ul>
            <li>Програмата е подходяща за студенти в бакалавърска степен на обучение, преминали трети курс на обучение или студенти в магистърска степен на обучение, както и за наскоро дипломирани млади специалисти.</li>
            <li>Като стажант в нашата компания, вие получавате социалните придобивки, като дневна храна в столовата, транспорт от и до работното място.</li>
        </ul>
        <p class="strong">Области за провеждане на стажа:</p>
        <ul>
            <li>- металургия</li>
            <li>- инженерна химия</li>
            <li>- хидравлична и пневматична техника</li>
            <li>- инструментална екипировка, машини и механизми</li>
            <li>- информационни технологии</li>
            <li>- автоматизирани системи за управление</li>
            <li>- индустриален мениджмънт</li>
        </ul>
        <p class="strong"> Как да кандидатствате:</p>
        <p class="indent">Моля, изпратете молба, автобиография, мотивационно писмо, като посочите желаната област за провеждане на стажа на адрес::</p>
        <p class="no-margin">E-mail: <a href="mailto:hr@alcomet.eu">hr@alcomet.eu</a></p>
        <p class="no-margin">Индустриална зона 2</p>
        <p class="no-margin">гр. Шумен, п.к. 9700</p>
        <p class="no-margin">Алкомет АД</p>
        <p class="no-margin">отдел "Човешки ресурси"</p>
        -->
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.full-width {
    width:100% !important;
    margin-top:50px;
}
.careers-scholarships-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.careers-scholarships-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.careers-scholarships-content > ul {
  list-style: disc;
  padding-left: 20px;
  width: 60%;
}
.careers-scholarships-content ul li {
  display: block;
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
}
.careers-scholarships-content .no-margin {
  margin: 0;
}
.careers-scholarships-content .underline {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .careers-scholarships-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .careers-scholarships-content > ul {
    padding-left: 50px;
    padding-right: 30px;
    width: 100%;
  }
  .careers-scholarships-content ul li {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/Scholarships.vue